export const LINE_CHART_CONFIG = {
	// TODO: Implement
};
